var map = {
	"./Produktbeispiel_1.jpg": "7fe7",
	"./Produktbeispiel_2.jpg": "9beb",
	"./Produktbeispiel_3.jpg": "d5c6",
	"./Produktbeispiel_4.jpg": "404b",
	"./Produktbeispiel_5.jpg": "fee9",
	"./Produktbeispiel_6.jpg": "a334",
	"./Produktbeispiel_7.jpg": "5860",
	"./Produktbeispiel_8.jpg": "a29e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cbcb";